(function () {
    'use strict';

    angular
        .module('app.surveys')
        .factory('survey.dialog', surveyDialog);

    surveyDialog.$inject = ['$uibModal', 'opsIncludeVersion'];
    /* @ngInject */
    function surveyDialog($uibModal, opsIncludeVersion) {
        var service = {
            display: display
        }
        
        return service;

        function display(item) {
            var modalOptions = {
                templateUrl: 'app/dialogs/_takeSurvey.html?v=' + opsIncludeVersion,
                controller: TakeSurveryModalInstance,
                controllerAs: 'vm',
                keyboard: true,
                size: 'lg',
                resolve: {
                    options: function () {
                        return {
                            item: item
                        };
                    }
                }
            };

            return $uibModal.open(modalOptions).result;
        }
    }


    TakeSurveryModalInstance.$inject = ['$uibModalInstance', 'options', 'common', 'dataservice'];

        /* @ngInject */
    function TakeSurveryModalInstance($uibModalInstance, options, common, dataservice) {
        var vm = this;
        vm.okText = "Submit";
        vm.surveyComplete = false;

        vm.chartOptions = {
            legend: { display: true, position: 'bottom' },
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        var allData = data.datasets[tooltipItem.datasetIndex].data;
                        var tooltipLabel = data.labels[tooltipItem.index];
                        var tooltipData = allData[tooltipItem.index];
                        var total = 0;
                        for (var i in allData) {
                            total += allData[i];
                        }
                        var tooltipPercentage = Math.round((tooltipData / total) * 100);
                        return tooltipLabel + ': ' + tooltipPercentage + '%';
                    }
                }
            }
        };
        vm.surveyResults = [];

        vm.ok = function () {
            if (vm.surveyComplete) {
                $uibModalInstance.close('ok');
                return;
            }
            if (validate()) {
                save();
            }
        };

        vm.optOut = function () {
            dataservice.saveItem('api/Surveys/OptOut', vm.item).then(function (saveResult) {
                $uibModalInstance.dismiss();
            }).catch(function (error) {
            });
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss();
        };
       
        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
            }, function (error) { });
        }


        function getItems() {
            return dataservice.getItems('api/Surveys/GetSurveyToTake/' + options.item.SurveyUId).then(function (response) {
                var data = response.data;
                vm.item = data;
                return vm.items;
            }, function (error) { });
        }

        function save() {
            vm.isSaving = true;
            dataservice.saveItem('api/Surveys/AddResponse', vm.item).then(function (saveResult) {
                vm.isSaving = false;
                vm.surveyComplete = true;
                vm.okText = "Close";
                var data = saveResult.data;
                
                for (var i = 0; i < data.length; i++) {
                    if (data[i].AnswerType !== 2 && data[i].AnswerType !== 1) {
                        vm.surveyResults.push({ Question: data[i].Question, ChartData: data[i].Data, ChartLabels: data[i].Labels });
                    }
                }
                


            }).catch(function (error) {

            });
        }


        function validate() {
            for (var i = 0; i < vm.item.Questions.length; i++) {
                var q = vm.item.Questions[i];

                if (q.AnswerType == 7) {

                    var tp = 'timePicker' + q.ID;
                    if (vm.takeSurveyForm[tp].$invalid) {

                        common.logger.error(q.Question + " must be a valid time");
                        return false;
                    }
                }

                if (q.AnswerType == 6) {
                    var dp = 'datePicker' + q.ID;
                    if (vm.takeSurveyForm[dp].$invalid) {
                        common.logger.error(q.Question + " must be a valid date");
                        return false;
                    }
                }


                if (q.Required) {
                    if (q.AnswerType == 4) {
                        var isItemSelected = false;
                        for (var j = 0; j < q.Items.length; j++) {
                            if (q.Items[j].Selected) {
                                isItemSelected = true;
                                break;
                            }
                        }
                        if (!isItemSelected) {
                            common.logger.error(q.Question + " must have at least one item selected");
                            return false;
                        }
                    }
                    else {
                        if (!q.Answer) {
                            common.logger.error(q.Question + " is required");
                            return false;
                        }
                    }
                }
            }
            return true;
        }

    }
})();
